exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rheostat {\n  overflow: visible;\n}\n\n.rheostat-background {\n  background-color: #fcfcfc;\n  border: 1px solid #d8d8d8;\n  position: relative;\n}\n\n.rheostat-progress {\n  background-color: #abc4e8;\n  position: absolute;\n}\n\n.rheostat-handle {\n  background-color: #fff;\n  border: 1px solid #d8d8d8;\n  border-radius: 20%;\n  height: 24px;\n  outline: none;\n  z-index: 2;\n  width: 24px;\n}\n\n.rheostat-handle:before,\n.rheostat-handle:after {\n  content: '';\n  display: block;\n  position: absolute;\n  background-color: #dadfe8;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/rheostat/css/slider.css
// module id = 632
// module chunks = 0